import React from "react";

// Catches any render error so a single bug can't white-screen the whole app.
// The resume autosaves to localStorage, so "Reload" recovers the user's work.
// Best-effort logs the crash to the admin's service-health table for visibility.
export default class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { crashed: false }; }
  static getDerivedStateFromError() { return { crashed: true }; }
  componentDidCatch(err, info) {
    try {
      const url = process.env.REACT_APP_SUPABASE_URL, key = process.env.REACT_APP_SUPABASE_KEY;
      if (url && key) fetch(`${url}/rest/v1/system_errors`, {
        method: "POST",
        headers: { "content-type": "application/json", apikey: key, authorization: `Bearer ${key}`, prefer: "return=minimal" },
        body: JSON.stringify({
          source: "client",
          status: 0,
          reason: String((err && err.message) || err || "render error").slice(0, 200),
          detail: String((info && info.componentStack) || "").slice(0, 400),
        }),
      }).catch(() => {});
    } catch {}
  }
  render() {
    if (!this.state.crashed) return this.props.children;
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#060a16", color: "#e6e9ef", fontFamily: "system-ui,-apple-system,'Segoe UI',Roboto,sans-serif", padding: 24 }}>
        <div style={{ maxWidth: 420, textAlign: "center" }}>
          <div style={{ fontSize: 40, marginBottom: 12 }}>🛠️</div>
          <h1 style={{ fontSize: 20, fontWeight: 700, margin: "0 0 8px" }}>Something went wrong</h1>
          <p style={{ fontSize: 14, color: "#9aa3b2", lineHeight: 1.6, margin: "0 0 20px" }}>
            Don’t worry — your resume is saved in this browser. Reloading will bring it right back.
          </p>
          <button onClick={() => window.location.reload()}
            style={{ background: "#c79200", color: "#1a1400", border: 0, borderRadius: 12, padding: "11px 22px", fontWeight: 700, fontSize: 14, cursor: "pointer" }}>
            Reload Resume88
          </button>
        </div>
      </div>
    );
  }
}
